import { stringify } from '../utils/stringify.js';
import { BaseError } from './base.js';
import { getUrl } from './utils.js';
export class HttpRequestError extends BaseError {
  constructor(_ref) {
    let {
      body,
      details,
      headers,
      status,
      url
    } = _ref;
    super('HTTP request failed.', {
      details,
      metaMessages: [status && "Status: ".concat(status), "URL: ".concat(getUrl(url)), body && "Request body: ".concat(stringify(body))].filter(Boolean)
    });
    Object.defineProperty(this, "name", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: 'HttpRequestError'
    });
    Object.defineProperty(this, "body", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "headers", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "status", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "url", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    this.body = body;
    this.headers = headers;
    this.status = status;
    this.url = url;
  }
}
export class WebSocketRequestError extends BaseError {
  constructor(_ref2) {
    let {
      body,
      details,
      url
    } = _ref2;
    super('WebSocket request failed.', {
      details,
      metaMessages: ["URL: ".concat(getUrl(url)), "Request body: ".concat(stringify(body))]
    });
    Object.defineProperty(this, "name", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: 'WebSocketRequestError'
    });
  }
}
export class RpcRequestError extends BaseError {
  constructor(_ref3) {
    let {
      body,
      error,
      url
    } = _ref3;
    super('RPC Request failed.', {
      cause: error,
      details: error.message,
      metaMessages: ["URL: ".concat(getUrl(url)), "Request body: ".concat(stringify(body))]
    });
    Object.defineProperty(this, "name", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: 'RpcRequestError'
    });
    Object.defineProperty(this, "code", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    this.code = error.code;
  }
}
export class TimeoutError extends BaseError {
  constructor(_ref4) {
    let {
      body,
      url
    } = _ref4;
    super('The request took too long to respond.', {
      details: 'The request timed out.',
      metaMessages: ["URL: ".concat(getUrl(url)), "Request body: ".concat(stringify(body))]
    });
    Object.defineProperty(this, "name", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: 'TimeoutError'
    });
  }
}
//# sourceMappingURL=request.js.map